export default "__VITE_ASSET__de1574dc__"